import {Api} from "@/repository/api";

export class CustomFieldRepository extends Api {
    constructor() {
        super("custom_fields");
    }
}